import { useEffect } from 'react';
import { setCanonical, setMeta } from '../utils/seo';
import { SponsorBanner, AdSensePlaceholder } from './AdSlots';

export default function TermsPage() {
  useEffect(() => { setCanonical('/terms'); setMeta('Terms of Service', 'TrueFitGuide terms of service.'); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12">
      <h1 className="font-['Cormorant_Garamond'] text-4xl font-light tracking-tighter text-[#1C1917] mb-8">Terms of Service</h1>
      <div className="space-y-6 text-sm text-[#78716C] leading-relaxed">

        <h3 className="text-lg font-semibold text-[#1C1917]">1. Acceptance of Terms</h3>
        <p>By accessing and using TrueFitGuide.com ("the Platform"), you accept and agree to be bound by these terms. If you do not agree to these terms, please do not use this service.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">2. Description of Service</h3>
        <p>Our platform provides:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Clothing size charts and conversion tools for 50+ global brands</li>
          <li>International size conversion between US, UK, EU, Japan, Korea, and Australia</li>
          <li>A "Find My Size" quiz based on body measurements</li>
          <li>Size comparison tools between different brands</li>
          <li>Body type style guide with clothing recommendations</li>
          <li>An AI-powered size guide chatbot ("Sarah")</li>
          <li>Blog content about clothing sizing and fashion</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">3. Sizing Disclaimer and Limitations</h3>
        <div className="bg-[#FAF8F4] border border-[#E8E2D9] p-4">
          <p className="font-semibold text-[#1C1917] mb-2">IMPORTANT:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>This service is NOT professional sizing or fitting advice</li>
            <li>All size charts, conversions, and recommendations are <strong>approximate</strong> and for informational purposes only</li>
            <li>Actual sizes vary by brand, style, cut, fabric, and individual item</li>
            <li>Always verify with the specific retailer's size chart before purchasing</li>
            <li>The AI chatbot ("Sarah") is an artificial intelligence assistant, NOT a fashion professional</li>
            <li>TrueFitGuide is NOT affiliated with any brand listed on this website</li>
            <li>We are NOT responsible for incorrect purchases based on our size information</li>
          </ul>
        </div>

        <h3 className="text-lg font-semibold text-[#1C1917]">4. User Responsibilities</h3>
        <p>As a user, you agree to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Use the platform responsibly and at your own risk</li>
          <li>Verify sizing information with the retailer before purchasing</li>
          <li>Not use the service for any illegal or unauthorized purpose</li>
          <li>Take full responsibility for your purchasing decisions</li>
          <li>Not rely solely on this platform for sizing decisions</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">5. Affiliate Marketing and Advertising Disclosure</h3>
        <p>This platform contains affiliate links and advertisements, including Google AdSense. By using this service, you acknowledge that:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>We may earn commissions from affiliate purchases made through links on this site (including Amazon Associates)</li>
          <li>Google AdSense displays third-party advertisements which may use cookies</li>
          <li>Sponsored banners and affiliate links are clearly marked</li>
          <li>We are not responsible for third-party products, services, or advertisements</li>
          <li>All affiliate relationships are disclosed in accordance with FTC guidelines (16 CFR Part 255)</li>
          <li>You pay the same price whether you use our affiliate link or purchase directly</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1C1917]">6. Intellectual Property</h3>
        <p>All original content on this platform, including text, graphics, logos, and software, is the property of TrueFitGuide.com and is protected by copyright laws. Brand names and logos referenced belong to their respective owners and are used solely for identification purposes. You may not reproduce, distribute, or create derivative works without express written permission.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">7. Limitation of Liability</h3>
        <div className="bg-[#FAF8F4] border border-[#E8E2D9] p-4">
          <p>TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>We provide this service "AS IS" and "AS AVAILABLE" without warranties of any kind</li>
            <li>We are not liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of the platform</li>
            <li>This includes but is not limited to: incorrect purchases, return shipping costs, or any inconvenience caused by inaccurate sizing information</li>
            <li>Our total liability shall not exceed the amount you paid for the service (which is zero, as the platform is free)</li>
          </ul>
        </div>

        <h3 className="text-lg font-semibold text-[#1C1917]">8. Indemnification</h3>
        <p>You agree to indemnify, defend, and hold harmless TrueFitGuide.com, its operators, affiliates, and partners from any claims, damages, losses, or expenses arising from your use of the platform or violation of these terms.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">9. Privacy and Data</h3>
        <p>Your privacy is important to us. Please review our <a href="/privacy" className="text-[#C5A028] hover:underline">Privacy Policy</a> to understand how we handle your information.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">10. Modifications to Terms</h3>
        <p>We reserve the right to modify these terms at any time without prior notice. Changes will be effective immediately upon posting. Your continued use constitutes acceptance.</p>

        <h3 className="text-lg font-semibold text-[#1C1917]">11. Governing Law</h3>
        <p>These terms shall be governed by and construed in accordance with the laws of the United States. Any disputes arising under these terms shall be resolved in the courts of competent jurisdiction.</p>

        <p className="text-xs text-[#78716C] mt-8">Last Updated: January 2026</p>
      </div>
      <SponsorBanner />
      <AdSensePlaceholder />
    </div>
  );
}
